import type React from "react"
import { useEffect, useRef } from "react"
import { Card } from "react-bootstrap"
import * as echarts from "echarts";

// @ts-ignore
const DonutChart: React.FC = ({ DonutChartData, title, subtitle }) => {
    const chartRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!chartRef.current) return

        const chart = echarts.init(chartRef.current)

        const option = {
            title: {
                text: DonutChartData?.title,
                subtext: DonutChartData?.subtitle,
                left: "center",
                top: title === "Request Breakdown by Outcome" ? "45%" : "40%",
                textStyle: {
                    fontSize: 22,
                    fontWeight: "bold",
                    color: "#000",
                },
                subtextStyle: {
                    fontSize: 14,
                    color: "#666",
                },
            },
            tooltip: {
                trigger: "item",
                formatter: "{b}: {c} ({d}%)",
            },
            legend: {
                bottom: "-1%",
                orient: "horizontal",
                data: DonutChartData && DonutChartData?.data?.map((item: any) => item.name),
                icon: 'circle'
            },
            series: [
                {
                    name: "Request Outcome",
                    type: "pie",
                    radius: title === "Request Breakdown by Outcome" ? ["60%", "80%"]: ['40%', '70%'],
                    center: title !== "Request Breakdown by Outcome" ? ["50%", "45%"] : ["50%", "50%"],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: "outside",
                        formatter: "{c}\n({d}%)",
                    },
                    labelLine: {
                        show: true,
                    },
                    data: DonutChartData && title !== "Request Breakdown by Outcome" ? DonutChartData?.data : DonutChartData?.data?.map((item: any) => ({
                        value: item.value,
                        name: item.name,
                        itemStyle: { color: item.color },
                    })),
                },
            ],
        };

        chart.setOption(option)

        const handleResize = () => {
            chart.resize()
        }

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
            chart.dispose()
        }
        //eslint-disable-next-line
    }, [DonutChartData])

    return (
        <Card className="h-100 shadow-sm">
            <Card.Body className="p-3">
                <div>
                    <p className="m-0" style={{ color: '#18181B', fontSize: '20px', fontWeight: '400' }}>{title}</p>
                    <p className="m-0" style={{ color: '#71717A', fontSize: '14px', fontWeight: '400' }} >{subtitle}</p>
                </div>
                <div ref={chartRef} style={{ width: "100%", height: "400px" }} />
            </Card.Body>
        </Card>
    )
}

export default DonutChart;
